import { useCallback } from 'react';
import { useStore, StoreTypes } from 'context';
import { EventBus } from 'events/EventBus';
import { ReaderToolsEvent } from 'events/EventTypes';
import * as types from 'constants/actionTypes';

export const useTimerCommand = () => {
    const [_, globalDispatch] = useStore(StoreTypes.global);

    const execute = useCallback(async () => {
        try {
          globalDispatch({ type: types.OPEN_TIMER_MODAL })
          EventBus.emit({
            event: ReaderToolsEvent.ClickReaderToolBoxEvent,
            payload: {
              isToolboxShow: false
            }
          })
        } catch (e) {
            console.error('TimerCommand execute error', e);
        }
    }, [globalDispatch]);

    return { execute };
};
